import {
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/icons/ArrowLeft.tsx
import React from "react";
var SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#arrow-left_svg__a)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414L7.828 11Z"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "arrow-left_svg__a" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
);
var ArrowLeft_default = SvgArrowLeft;

export {
  ArrowLeft_default
};
